<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Equipment Delivery Form</h5>

    <button type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-warning"
      style="margin-right: 5px;"> Search Customer
      <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div [hidden]="Data_Seleted_Customer.id==0">

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Behfa Customer Code </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Customer Delivery Method </label>
            <select [(ngModel)]="Inperson" name="Inperson" class="custom-select">
              <option value="-1">Select</option>
              <option value="1">In Person</option>
              <option value="0">Tipax</option>
            </select>
          </div>
        </div>

      </form>

      <div [hidden]="Inperson=='-1'">

        <form [hidden]="Inperson!='1'">
          <div class="row">

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> Recipient </label>
              <select [(ngModel)]="PersoneType" name="PersoneType" class="custom-select">
                <option value="0">Select</option>
                <option value="1">Representative</option>
                <option value="2">Motorcycle Courier</option>
                <option value="3">Taxi Service</option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> Name </label>
              <input type="text" [(ngModel)]="InpersoneName" name="InpersoneName" class="form-control"
                placeholder="Type here... " />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> Contact Number </label>
              <input type="text" [(ngModel)]="InpersonePhone" name="InpersonePhone" class="form-control"
                placeholder="Type here... " />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> National ID</label>
              <input type="number" class="form-control" [(ngModel)]="InpersoneCodeMeli" name="InpersoneCodeMeli"
                class="form-control" placeholder="Type here... " />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Customer Delivery Description </label>
              <textarea class="form-control" [(ngModel)]="InpersoneDsc" name="InpersoneDsc" class="form-control"
                placeholder="Type here... "></textarea>
            </div>
          </div>

        </form>

        <form [hidden]="Inperson!='0'">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> Tracking Code </label>
              <input type="text" [(ngModel)]="CodeRahgiri" name="CodeRahgiri" class="form-control"
                placeholder="Type here... " />
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1">Postal Handover Date</label>
              <input type="text" #datepickerInputDeliver placeholder="Type here..." class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
                [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputDeliver">
              </ng-persian-datepicker>
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1">Responsible Calibration Technician</label>
              <select class="custom-select" [(ngModel)]="KarshnasMasol" name="KarshnasMasol">
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_KarshnasMasol" [value]="item.id">{{item.name}}</option>

              </select>
            </div>
          </div>


        </form>

        <br />
        <br />

        <ul>
          <li>Click the relevant field before scanning</li>
          <li>Press Enter to verify the scanned code</li>
          <li>Press Esc to clear the form</li>

        </ul>

        <br />
        <br />

        <form>


          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Click the field below before scanning the QR code <i
                  class="fa fa-arrow-down"></i>
              </label>
              <input #QRCodeInputDelivery type="text" (keyup.enter)="QRCodeInputDelivery_Enter()"
                (keyup.esc)="QRCodeInputDelivery_Esc()"
                style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;"
                class="form-control EnglishClm" placeholder="Click here...">
              <p [hidden]="!Procssing"> Please wait... <i class="fa fa-spin fa-refresh"></i> </p>

            </div>
          </div>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

          <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDelivery(datepickerInputDeliver.value)" type="button"
            [disabled]="Info_Delivery_List.length==0" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Delivery of Scanned Equipment </button>

          <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDelivery_Enter()" type="button"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Verify Instrument ID
          </button>

          <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa  fa-recycle"></i> Start Over </button>


        </form>

        <br />
        <br />

        <div class="row" *ngIf="Info_Delivery_List.length>0">
          <div class="form-group col-md-12">
            <div class="table-responsive">
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <thead style="background-color: #489b39; color: white;">
                  <tr>
                    <th>#</th>
                    <th>Instrument Code</th>
                    <th>Instrument Serial Number</th>
                    <th *ngIf="!FormSubmitted">QR Code</th>
                    <th *ngIf="FormSubmitted">System Message</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Info_Delivery_List">
                    <td>{{Info_Delivery_List.indexOf(item)+1}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.title}}</td>
                    <td *ngIf="item.id==0">{{item.dsc}}</td>
                    <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                    <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                    <td>
                      <button *ngIf="!FormSubmitted" (click)="Info_Delivery_Remove(Info_Delivery_List.indexOf(item))"
                        class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>

<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>
